import * as AvatarPrimitive from '@radix-ui/react-avatar'
import { ComponentProps, FC } from 'react'
import { keyframes, styled } from '../../config'

const appear = keyframes({
  '0%': { opacity: 0 },
  '100%': { opacity: 1 }
})

const Root = styled(AvatarPrimitive.Root, {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  userSelect: 'none',
  background: 'transparent'
})
const _Image = styled(AvatarPrimitive.Image, {
  borderRadius: 'inherit',
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  animation: `500ms ease-out ${appear}`
})
const Fallback = styled(AvatarPrimitive.Fallback, {
  borderRadius: 'inherit',
  width: '100%',
  height: '100%',
  backgroundColor: '$blackA050',
  animation: `200ms ease-out ${appear}`
})

export const ImagePrimitive = { Root, Image: _Image, Fallback }

/**
 * Lazy Image.
 * Has a Fallback mechanism that renders a gray container instead of an image in case of error or loading state after 500ms
 * Animated appear
 */
export const Image: FC<ComponentProps<typeof Root> & { src?: string }> = ({ src, ...props }) => (
  <Root {...props}>
    <_Image src={src} />
    <Fallback delayMs={500} />
  </Root>
)
